<template>
    <header>
        <nav class="navbar navbar-expand-lg navbar-dark bg-danger">
            <div class="container">
                <router-link class="navbar-brand" to="/">
                    <img src="@/assets/img/logo.png" width="200" height="40" alt="logo">
                </router-link>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".collapse">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse">
                    <ul class="navbar-nav mr-auto">
                        <li v-for="x in menu" :key="x.Path" :class="['nav-item',{'dropdown':x.Directory}]">
                            <template v-if="!x.Directory">
                                <router-link :to="x.Path" :class="['nav-link',isActice(x.Path)]">{{x.Title}}</router-link>
                            </template>
                            <template v-else>
                                <a href="#" :class="['nav-link','dropdown-toggle',isDirActice(x.Path)]" data-toggle="dropdown">
                                    <template v-if="language.value==='ZH-TW'">{{x.Title}}</template>
                                    <template v-else-if="language.value==='EN-US'">{{x.EngTitle}}</template>
                                </a>
                                <div class="dropdown-menu bg-danger">
                                    <router-link v-for="y in x.children" :key="y.Path" :to="y.Path" :class="['nav-link','dropdown-item',isActice(y.Path)]">
                                        <template v-if="language.value==='ZH-TW'">{{y.Title}}</template>
                                        <template v-else-if="language.value==='EN-US'">{{y.EngTitle}}</template>
                                    </router-link>
                                </div>
                            </template>
                        </li>
                    </ul>
                    <ul class="navbar-nav ml-auto">
                        <li>
                            <div v-if="islogin" class="nav-link pointer">
                                <el-dropdown trigger="click" @command="changeLanguage" class="text-white">
                                    <span class="el-dropdown-link">
                                        {{ language.title }}<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(item,index) in languageList" :key="index" :command="index">
                                            {{ item.title }}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </li>
                        <li>
                            <div v-if="islogin" class="nav-link pointer" @click="logout()">
                                <template v-if="language.value==='ZH-TW'">登出</template>
                                <template v-else-if="language.value==='EN-US'">Logout</template>
                            </div>
                            <div v-else class="nav-link pointer" @click="open()">登入</div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="login block">
            </div>
            <div class="login form">
                <div class="row">
                    <div class="col-12">
                        <form-input v-model="vm.account" id="account" label="帳號" type="text"></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.password" id="password" label="密碼" type="password"></form-input>
                    </div>
                    <div class="col-4" hidden>
                        <label><input v-model="vm.LDAP" type="checkbox" value="true" />LDAP</label>
                        <!-- todo: sso line 46 -->
                        <label><input v-model="vm.SSO" type="checkbox" value="true" />SSO</label>
                    </div>
                    <div class="col-12 text-right">
                        <b-button variant="success" @click="post">確定</b-button>
                        <b-button variant="info" @click="close">關閉</b-button>
                    </div>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
    import { parameter } from '@/axios/api.js';

    export default {
        name: 'pageHeader',
        data: function () {
            return {
                timer: '', islogin: false, menu: [], languageList: [],
                vm: { account: '', password: '', LDAP: false, SSO: true },
                language: {
                    value: "ZH-TW",
                    title: "繁體中文"
                },
            }
        },
        created: function () {
            this.checkCookies();
            setInterval(this.checkCookies, 5000);

            if (this.islogin) {
                this.getLanguageList();
                setInterval(this.getLanguageList, 2000);
                this.getMenu();
            }
            else {
                //this.post();
            }
        },
        methods: {
            isDirActice: function (path) {
                return { 'active': this.$route.path.indexOf(path) == 0 };
            },
            isActice: function (path) {
                return { 'active': this.$route.path == path };
            },
            getMenu: function () {
                parameter.usermenu().then(x => this.menu = x.data);
            },
            getLanguageList: function () {
                parameter.userlanguage().then(x => this.languageList = x.data);
            },
            checkCookies: function () {
                this.islogin = this.$cookies.isKey('g');
            },
            open: function () {
                window.document.getElementsByTagName("body")[0].classList.add("login");
            },
            close: function () {
                window.document.getElementsByTagName("body")[0].classList.remove("login");
            },
            post: function () {
                this.$http({ method: 'post', url: "api/Identity/Login", data: this.vm })
                   .then(res => {
                       this.$cookies.set('g', res.data, 0, "/");
                       this.state = true;
                       this.close();
                       this.getMenu();
                   })
            },
            logout: function () {
                this.$cookies.remove('g', null, 'saai.mcut.edu.tw');
                this.$cookies.remove('g');
                this.islogin = false;
                this.menu = [];
                this.languageList = [];
                this.$router.push({ path: '//' });
            },
            changeLanguage(index) {
                this.language = this.languageList[index];
                switch (this.language.value) {
                    case "ZH-TW":
                        this.$i18n.locale = "tw";
                        break;
                    case "EN-US":
                        this.$i18n.locale = "en";
                        break;
                }
            }
        }
    };
</script>

<style>
    body .login { display: none; }
        body.login .login { display: initial; }
    body.login { overflow-x: hidden; overflow-y: hidden; }
        body.login .login { position: fixed; top: 0; right: 0; bottom: 0; left: 0; overflow: hidden; }
        body.login .block { z-index: 1008; background-color: black; opacity: 0.5; }
        body.login .form { z-index: 1009; width: 300px; height: 250px; border-radius: 5px; padding: 25px; background-color: white; margin: auto; }
</style>